import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";

@Component({
  selector: 'page-report-edit-repair',
  templateUrl: 'report-edit-repair.html',
})
export class ReportEditRepairPage {

  index = 0;
  item: any;
  items = [];
  form: FormGroup;

  datePickerOptions: any = {
    buttons: [{
      text: 'Leeg maken',
      handler: () => {
        this.form.controls['time_manufactured'].setValue(null);
      }
    }]
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public barcodeScanner: BarcodeScanner,
    public viewCtrl: ViewController
  ) {
    this.index = this.navParams.get('index');
    this.item = this.navParams.get('item');
    this.items = this.navParams.get('items');
    this.form = this.formBuilder.group({
      time_manufactured: [(this.item.time_manufactured ? this.item.time_manufactured : '')],
      description: [(this.item.description ? this.item.description : ''), Validators.required],
      code: [(this.item.code ? this.item.code : '')],
      part_title: [(this.item.part_title ? this.item.part_title : '')],
      part_ean: [(this.item.part_ean ? this.item.part_ean : '')],
      remark: [(this.item.remark ? this.item.remark : '')],
    });
  }

  scanBarcode(field){
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      if(barcode) this.form.get(field).setValue(barcode);
    }).catch(err => {
      console.log('Error', err);
    });
  }

  save(){
    Object.assign(this.item, this.form.value);
    this.closeModal();
  }

  delete(){
    this.items.splice(this.index, 1);
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportEditRepairPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-edit-repair/report-edit-repair.ts